import { Input } from '../../../../ui/input';
import type { BaseFieldProps, NumberFieldSchema } from '../../../types';

export function NumberFieldInput({
  field,
  value,
  onChange,
  error,
}: BaseFieldProps<NumberFieldSchema, number | '' | null | undefined>) {
  return (
    <Input
      id={field.id}
      type="number"
      step={field.step || 'any'}
      min={field.min}
      max={field.max}
      placeholder={field.placeholder}
      value={value === undefined || value === null ? '' : value}
      onChange={(e) => {
        const val = e.target.value;
        onChange?.(val === '' ? undefined : Number(val));
      }}
      aria-invalid={!!error}
    />
  );
}

export function NumberFieldView({
  value,
  viewPlaceholder,
}: BaseFieldProps<NumberFieldSchema, number | '' | null | undefined>) {
  if (value === undefined || value === null || value === '') {
    return <span className="text-muted-foreground text-sm">{viewPlaceholder || '- -'}</span>;
  }

  return <span className="text-sm font-medium">{value}</span>;
}
